import { loadStripe } from '@stripe/stripe-js';
import type { Stripe } from '@stripe/stripe-js';
import { getRuntimeConfig } from '../../config/runtime.js';

const clients = new Map<string, Promise<Stripe | null>>();
export function getStripeClient(stripeAccountId: string | null) {
  const key = getRuntimeConfig('VITE_STRIPE_PUBLISHABLE_KEY');
  if (!key) return null;
  const scope = `${key}:${stripeAccountId ?? 'platform'}`;
  let client = clients.get(scope);
  if (!client) {
    client = loadStripe(key, stripeAccountId ? { stripeAccount: stripeAccountId } : undefined);
    clients.set(scope, client);
  }
  return client;
}
